import delegate from 'delegate';
import { str2json } from '@src/utils';

export default {
  init: (app) => {
    const ctx = app;

    delegate(
      document.body,
      '.has-link',
      'click',
      (e) => {
        // If already a link bailout
        if (e.target.tagName == 'A' || e.target.tagName == 'button' || e.target.tagName == 'BUTTON') {
          return;
        }
        const link = e.delegateTarget.querySelector('a');
        if (link && link.href) {
          e.preventDefault();
          window.location.href = link.href;
        }
      },
      false
    );

    delegate(
      document.body,
      '[data-action]',
      'click',
      (e) => {
        e.preventDefault();
        const evData = str2json(e.delegateTarget.dataset.action);
        ctx.emit(evData.type, { identifier: evData.target, action: evData.action, payload: evData.payload });
      },
      false
    );

    if (!navigator.cookieEnabled) {
      document.body.classList.add('cookies-not-supported');
    }
    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
  },
};
